import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll-watch"
export default class extends Controller {
  static targets = ['scrollable']

  static values = {
    threshold: { type: Number, default: 0.9 }
  }

  static classes = ['scrollY', 'scrollX']

  connect() {
    this.scrollable.addEventListener('scroll', this.handleScroll, { passive: true })
    this.scrollable.addEventListener('scrollend', this.handleScrollEnd)
  }

  disconnect() {
    this.scrollable.removeEventListener('scroll', this.handleScroll)
    this.scrollable.removeEventListener('scrollend', this.handleScrollEnd)
  }

  handleScroll = () => {
    this.updateScrollState()
  }

  handleScrollEnd = () => {
    this.updateScrollState()
  }

  updateScrollState() {
    const { scrollTop, scrollLeft } = this.scrollable
    this.element.classList.toggle(this.scrollYClass, scrollTop > 0)
    this.element.classList.toggle(this.scrollXClass, scrollLeft > 0)
  }

  get scrollable() {
    if (this.hasScrollableTarget) {
      return this.scrollableTarget
    } else {
      return this.element
    }
  }
}
